module.exports = __webpack_public_path__ + "img/54.d605337f.jpg";